import { createSlice } from "@reduxjs/toolkit";

export const blackListSlice = createSlice({
    name: "blacklist",
    initialState: {value:{
        company: {
            blacklistcompany: '',
            companytype: '',
            companyreg: '',
            taxnumber: '',
            address:'',
            companyphone: '',
            companyemail: '' 
        },
        representative: {
            type: '',
            typeother: '',
            title: '',
            firstname: '',
            lastname: '',
            marital: '',
            IDtype: '',
            ID: '',
            birthdate: '',
            sex: '',
            email: '',
            phone: ''
        },
        representative2: {
            type: '',
            typeother: '',
            title: '',
            firstname: '',
            lastname: '',
            marital: '',
            IDtype: '',
            ID: '',
            birthdate: '',
            sex: '',
            email: '',
            phone: ''
        },
        representative3: {
            type: '',
            typeother: '',
            title: '',
            firstname: '',
            lastname: '',
            marital: '',
            IDtype: '',
            ID: '',
            birthdate: '',
            sex: '',
            email: '',
            phone: ''
        },
        incident: {
            product:'',
            category:'',
            amount_applied:'',
            amount_lost:'',
            incidentdate:'',
            casenumber:'',
            information:''
        },
        documents: {
            files: []
        },
        blacklist: {
            userId:''
        }
    }},
    reducers: {
        addcompany: (state, action) => {
            state.value.company = action.payload;
        },
        addrepresentative: (state, action) => {
            state.value.representative = action.payload;
        },
        addrepresentative2: (state, action) => {
            state.value.representative2 = action.payload;
        },
        addrepresentative3: (state, action) => {
            state.value.representative3 = action.payload;
        },
        addincident: (state, action) => {
            state.value.incident = action.payload;
        },
        adddocument: (state, action) => {
            state.value.documents = action.payload;
        },
        addblacklist: (state, action) => {
            state.value.blacklist = action.payload;
        }
    }
});

export const {addcompany, addrepresentative, addrepresentative2, addrepresentative3,  addincident, adddocument, addblacklist} = blackListSlice.actions;

export default blackListSlice.reducer;